import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./modal.scss";

export const UploadS3Modal = ({
  handleClose,
  show,
  handleUpload,
  selectedId,
  selectedTitle,
  handleDowload,
}) => {
  return (
    <div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>AWS S3 upload Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Confirm upload to AWS S3 bucket? {selectedId}:{selectedTitle}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className="w-full !rounded-md !max-w-28 !text-sm !bg-primary-blue h-[43px] !border-primary-blue"
            onClick={handleDowload}
            variant="primary"
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
